var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
// NEW_IMPLEMENTATION_DELETE_ATTACHMENT
var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation NewImplementationDeleteAttachment($id: ID!) {\n    newImplementationDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"], ["\n  mutation NewImplementationDeleteAttachment($id: ID!) {\n    newImplementationDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"])));
export default function useNewImplementationDeleteAttachment() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'newImplementationDeleteAttachment',
        successMessage: 'Attachment deleted'
    }), onNewImplementationAttachmentDelete = _a.onMutate, loading = _a.loading;
    return { onNewImplementationAttachmentDelete: onNewImplementationAttachmentDelete, loading: loading };
}
var templateObject_1;
